module.exports = __webpack_public_path__ + "media/stylesheets/images/lp/feature-push-eb97ca797c36dbd2fb581ab2794a2248.gif";